import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileValidators } from 'ngx-file-drag-drop';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';
import { jsPDF } from 'jspdf';
import * as pdfjsLib from 'pdfjs-dist';

@Component({
  selector: 'app-projects-providers-add',
  templateUrl: './projects-providers-add.component.html',
  styleUrls: ['./projects-providers-add.component.scss']
})
export class ProjectsProvidersAddComponent implements OnInit {

  bodyForm : FormData = new FormData(); 
  form!: FormGroup;
  fileControl = new FormControl([],[FileValidators.uniqueFileNames, FileValidators.maxFileCount(1)]);
  providers : any = [];
  folder : any;
  id_campana_proyecto : any;
  nombre : any = "";
  hostName : any = "";
  listprovsurv : any = [];
  id_proyecto_diagrama : any;
  id_proy_vobo : any;
  id_fase : any;
  archivos : Array<any> = [];
  archivo_c: any;
  form_filled : Array<any> = [];
  members : any = [];
  filteredMembers: any = [];
  searchTerm: string = '';
  providerSelected: boolean = false;
  campaign: any;
  promociones: any;
  alias : any;
  showMontoInput: boolean = false;
  pop_config : any;
  total : number = 0;
  surveys_sended : any;
  usaArteCompartido = false;
  cargandoArte = true;
  arteDisponible = false;
  mensajeArteNoDisponible = '';
  archivoCompartidoRecortado: File | null = null;
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,    
    private fb : FormBuilder,    
    private projectService : ProjectsService,
    private main : MainService,
    private dialogRef: MatDialogRef<ProjectsProvidersAddComponent>,
  ) { 

    this.folder = this.data.folder;
    this.id_campana_proyecto = this.data.camp_id;
    this.nombre = this.data.nombre;
    this.listprovsurv = this.data.listprovsurv;
    this.id_proyecto_diagrama = this.data.id_proy_dia;
    this.id_proy_vobo = this.data.id_proy_vobo;
    this.id_fase = this.data.id_fase;
    this.form_filled = this.data.form_filled;
    this.campaign = this.data.campaign_id;
    this.promociones = this.data.promociones;
    this.alias = this.data.alias;
    this.pop_config = this.data.pop_config;
    this.surveys_sended = this.data.enviados;
    const imagenesCompartidas = this.data?.diagrama?.imagenes_compartidas;
    this.usaArteCompartido = this.data?.medioUsaImagenesCompartidas === true
      || imagenesCompartidas === true
      || Number(imagenesCompartidas) === 1;
    console.log("fdf", this.data);
    this.hostName = window.location.protocol + '//' + window.location.host + "/providers/";
  }

  ngOnInit(): void {
    this.getProviders();
    this.loadForm();
    this.preloadFormData();
    this.cargarArteParaProveedor();
    this.getPromotionsFile();
    console.log("da",this.data);
    this.calculateTotal();
  }

  private cargarArteParaProveedor(): void {
    if (this.usaArteCompartido) {
      this.cargarRecorteArteCompartido();
      return;
    }
    this.getArchivosByPhase();
  }

  getArchivosByPhase() {
    this.main.ShowLoading();
    const data = {
        id_diagrama: this.id_proyecto_diagrama,
        id_fase: this.id_fase
    }
    this.projectService.getdiagramFiles(data).subscribe((x: any) => {
      this.archivos = x.data;
      if(this.archivos.length == 0){
        this.arteDisponible = false;
        this.mensajeArteNoDisponible = 'Aún no hay un arte individual disponible para enviar al proveedor.';
        Swal.fire({
          icon: 'warning',
          title: 'Alerta',
          html: 'Aún no hay archivos de artes, por lo que no puede enviar el formulario hasta que el archivo de artes se encuentre disponible'
        });
      }else{
        this.archivo_c = JSON.parse(JSON.stringify(this.archivos[0])).file;
        this.arteDisponible = !!this.archivo_c;
        console.log(this.archivo_c);
      }

      this.cargandoArte = false;

    },
    (err:any) => {
      console.log(err);
      this.cargandoArte = false;
      this.arteDisponible = false;
      this.mensajeArteNoDisponible = 'No fue posible cargar el arte individual.';
      this.main.HideLoading();
    })
  }

  private async cargarRecorteArteCompartido(): Promise<void> {
    this.cargandoArte = true;
    this.arteDisponible = false;
    this.archivoCompartidoRecortado = null;
    this.mensajeArteNoDisponible = '';

    try {
      const diagrama = this.data.diagrama;
      const respuesta: any = await this.projectService.getDiagramaArchivoSharedImages({
        id_proyecto_campana: Number(this.campaign),
        id_phase: Number(this.id_fase),
        id_medio: Number(diagrama.id_medio),
        id_pop: Number(diagrama.id_pop)
      }).toPromise();
      const datos = respuesta?.data?.archivos || respuesta?.data || respuesta || [];
      const imagenesHijas = respuesta?.dataF || respuesta?.data?.dataF || [];
      const arte = (Array.isArray(datos) ? datos : [])
        .filter((item: any) => Number(item.deleted || 0) !== 1)
        .map((item: any) => ({
          ...item,
          imagenes: (Array.isArray(imagenesHijas) ? imagenesHijas : [])
            .filter((imagen: any) => Number(imagen.id_diagrama_archivos_compartidos) === Number(item.id))
            .sort((a: any, b: any) => Number(a.id) - Number(b.id))
        }))
        .sort((a: any, b: any) => {
          const diferencia = new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime();
          return diferencia || Number(b.id) - Number(a.id);
        })[0];

      const anotacion = this.obtenerAnotacionCompartida(arte?.selected_config, Number(diagrama.posicion || 1));
      if (!arte || !anotacion) {
        this.mensajeArteNoDisponible = 'Esta posición no tiene un arte compartido anotado. Debe anotarse antes de enviar el formulario al proveedor.';
        return;
      }

      this.archivoCompartidoRecortado = await this.generarRecorteCompartido(arte, anotacion);
      this.arteDisponible = !!this.archivoCompartidoRecortado;
      if (!this.arteDisponible) {
        this.mensajeArteNoDisponible = 'No fue posible generar el recorte del arte compartido.';
      }
    } catch (error) {
      console.error('No fue posible preparar el arte compartido para el proveedor.', error);
      this.mensajeArteNoDisponible = 'No fue posible preparar el recorte del arte compartido.';
    } finally {
      this.cargandoArte = false;
      this.main.HideLoading();
    }
  }

  private obtenerAnotacionCompartida(configuracion: any, posicion: number): any {
    let valor = configuracion;
    if (typeof valor === 'string') {
      try { valor = JSON.parse(valor); } catch { return null; }
    }
    const anotaciones = Array.isArray(valor) ? valor : valor?.anotaciones;
    return (Array.isArray(anotaciones) ? anotaciones : []).find((item: any) =>
      Number(item.posicion) === posicion
    ) || null;
  }

  private async generarRecorteCompartido(arte: any, anotacion: any): Promise<File> {
    const imagenes = Array.isArray(arte.imagenes) ? arte.imagenes : [];
    const pagina = Math.max(1, Number(anotacion.pagina || 1));
    const esMultiple = !arte.file && imagenes.length > 0;
    const url = esMultiple ? imagenes[pagina - 1]?.file : arte.file;
    if (!url) throw new Error('No se encontró el archivo correspondiente a la anotación.');

    const blob = await this.projectService.getFileViewerBlob(url).toPromise();
    if (!blob) throw new Error('No fue posible descargar el arte compartido.');
    const esPdf = String(arte.name || arte.file || '').toLowerCase().split('?')[0].endsWith('.pdf')
      || String(blob.type || '').toLowerCase().includes('pdf');
    const origen = esPdf
      ? await this.renderizarPaginaPdf(blob, pagina)
      : await this.renderizarImagen(blob);
    const recorte = this.recortarCanvas(origen, anotacion);

    if (esPdf) {
      const orientacion = recorte.width >= recorte.height ? 'landscape' : 'portrait';
      const pdf = new jsPDF({ orientation: orientacion, unit: 'px', format: [recorte.width, recorte.height] });
      pdf.addImage(recorte.toDataURL('image/png'), 'PNG', 0, 0, recorte.width, recorte.height);
      return new File([pdf.output('blob')], `arte_posicion_${this.data.diagrama.posicion}.pdf`, { type: 'application/pdf' });
    }

    const imagenRecortada = await new Promise<Blob>((resolve, reject) =>
      recorte.toBlob(resultado => resultado ? resolve(resultado) : reject(new Error('No fue posible crear la imagen.')), 'image/png')
    );
    return new File([imagenRecortada], `arte_posicion_${this.data.diagrama.posicion}.png`, { type: 'image/png' });
  }

  private async renderizarPaginaPdf(blob: Blob, pagina: number): Promise<HTMLCanvasElement> {
    if (!(globalThis as any).pdfjsWorker?.WorkerMessageHandler) {
      require('pdfjs-dist/build/pdf.worker.js');
    }
    const carga = pdfjsLib.getDocument({
      data: new Uint8Array(await blob.arrayBuffer()),
      isEvalSupported: false
    });
    const documento = await carga.promise;
    try {
      const paginaPdf = await documento.getPage(Math.min(pagina, documento.numPages));
      const viewport = paginaPdf.getViewport({ scale: 2 });
      const canvas = document.createElement('canvas');
      canvas.width = Math.ceil(viewport.width);
      canvas.height = Math.ceil(viewport.height);
      const contexto = canvas.getContext('2d');
      if (!contexto) throw new Error('No fue posible preparar el PDF.');
      await paginaPdf.render({ canvasContext: contexto, viewport }).promise;
      return canvas;
    } finally {
      if (typeof documento.destroy === 'function') await documento.destroy();
      else if (typeof documento.cleanup === 'function') documento.cleanup();
    }
  }

  private async renderizarImagen(blob: Blob): Promise<HTMLCanvasElement> {
    const url = URL.createObjectURL(blob);
    try {
      const imagen = await new Promise<HTMLImageElement>((resolve, reject) => {
        const elemento = new Image();
        elemento.onload = () => resolve(elemento);
        elemento.onerror = () => reject(new Error('No fue posible cargar la imagen.'));
        elemento.src = url;
      });
      const canvas = document.createElement('canvas');
      canvas.width = imagen.naturalWidth;
      canvas.height = imagen.naturalHeight;
      const contexto = canvas.getContext('2d');
      if (!contexto) throw new Error('No fue posible preparar la imagen.');
      contexto.drawImage(imagen, 0, 0);
      return canvas;
    } finally {
      URL.revokeObjectURL(url);
    }
  }

  private recortarCanvas(origen: HTMLCanvasElement, anotacion: any): HTMLCanvasElement {
    const x = Math.max(0, Math.round(Number(anotacion.x) * origen.width));
    const y = Math.max(0, Math.round(Number(anotacion.y) * origen.height));
    const ancho = Math.max(1, Math.min(origen.width - x, Math.round(Number(anotacion.ancho) * origen.width)));
    const alto = Math.max(1, Math.min(origen.height - y, Math.round(Number(anotacion.alto) * origen.height)));
    const recorte = document.createElement('canvas');
    recorte.width = ancho;
    recorte.height = alto;
    const contexto = recorte.getContext('2d');
    if (!contexto) throw new Error('No fue posible recortar el arte compartido.');
    contexto.drawImage(origen, x, y, ancho, alto, 0, 0, ancho, alto);
    return recorte;
  }

  loadForm() {
    this.form = this.fb.group({
      blob : [null],
      id_provider : [null, {validators:[Validators.required]}],
      provider_msg : [""],      
      membersSelected: [[]],
      monto : [""]
    });
  }

  preloadFormData(){
    this.bodyForm.append('folder', this.folder as string);
    this.bodyForm.append('id_campana_proyecto', this.id_campana_proyecto);
    this.bodyForm.append('id_proyecto_diagrama', this.id_proyecto_diagrama);
    this.bodyForm.append('id_proy_vobo', this.id_proy_vobo);
    this.bodyForm.append('id_fase', this.id_fase);
    this.bodyForm.append('formulario', JSON.stringify(this.form_filled));
  }


  onValueChange(files : any)
  { 
    if(files.length >= 2)
    {      
      files.splice(1, 1);
      Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: 'Sólo puede adjuntarse un documento'
      });
    }

    for (const item of files) {
      if(!(item.name.endsWith('.pdf')))
      {
        const index = files.indexOf(item);
  
        Swal.fire({
          icon: 'warning',
          title: 'Error',
          html: 'Solo se permiten documentos en formato .PDF'
        });
    
        if (index >= 0) {
          files.splice(index, 1);
        }
      }
    }
  }

  saveFile() {
    if(this.form.controls.id_provider.value != null){

      const selectedMembers = this.form.value.membersSelected;

      if(this.members.length == 0){
          Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'No se encontraron miembros activos para este proveedor. Verifica si ya fueron registrados o están desactivados.'
          });      
      } else if(!selectedMembers || selectedMembers.length === 0){
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'No hay miembros seleccionados, debe elegir al menos un miembro para enviar el formulario.'
        });
      }
      else{
          Swal.fire({
          title: '¿Estás seguro que deseas enviar el formulario?',
          text: '¡Se enviará notificación a Proveedor!',
          icon: 'warning',
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`
        }).then((result) => {      
          if (result.isConfirmed) {
              //this.uploadFile();
              this.sendFile();
          }
        });
      }

    }
  }

  getProviders(){
    this.projectService.getProviders().subscribe(
      (result:any) => {
       //this.main.HideLoading();
       this.providers = result.data;

      let listIdsProviders = this.listprovsurv.map((x:any)=> x.id_provider)

      this.providers = this.providers.filter((x:any)=>{ return !listIdsProviders.includes(x.id) });
      },
      (err:any) => {
        this.main.HideLoading();
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener registros',
            text: 'Ocurrió un error al obtener los registros de proveedores.'
          });
        
      }
    );
  }

  sendFile(){ 
      if (!this.arteDisponible) {
        Swal.fire('Arte no disponible', this.mensajeArteNoDisponible || 'No existe un arte disponible para enviar.', 'warning');
        return;
      }
      if (this.usaArteCompartido && this.archivoCompartidoRecortado) {
        this.bodyForm.append('blob', this.archivoCompartidoRecortado, this.archivoCompartidoRecortado.name);
      } else {
        this.bodyForm.append("file_c", this.archivo_c);
      }
      this.bodyForm.append("id_provider", this.form.controls.id_provider.value);
      this.bodyForm.append("provider_msg", this.form.controls.provider_msg.value);
      this.bodyForm.append("host", this.hostName);
      this.bodyForm.append("monto", this.showMontoInput ? this.form.controls.monto.value : "");
      this.bodyForm.append("members", this.form.value.membersSelected);


        Swal.fire({
          icon: 'info',
          title: 'Enviando formulario...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        this.projectService.uploadCampaignProviderFile(this.bodyForm).subscribe(
          (result:any)=>{
            if(result.message == 'Success'){
              Swal.fire({
                icon: 'success',
                title: 'Éxito',
                text: 'Formulario enviado exitosamente'          
              }).then(() => {            
                this.dialogRef.close({ reload: true });
              });
            }
            else {
              Swal.fire({
                icon: 'error',
                title: 'Error al enviar',
                text: 'Ocurrió un error al enviar el formulario, por favor vuelve a intentarlo.'
              });
            }
          },
          (err:any)=>{
            this.main.HideLoading();
            if(err.error.message == "Invalid file") {
              Swal.fire({
                icon: 'warning',
                title: 'Error',
                html: 'Solo se permiten documentos en formato .PDF'
              });
        
            }
            else {
              Swal.fire({
                icon: 'error',
                title: 'Error al enviar',
                text: 'Ocurrió un error al enviar el formulario, por favor vuelve a intentarlo.'
              });
            }
          }
        )
      
  }


  uploadFile(){ 
    if(this.form.value.blob != null && this.form.value.blob?.length!=0 ){
      this.bodyForm.append("blob", this.form.value.blob[0] as File);
      this.bodyForm.append("id_provider", this.form.controls.id_provider.value);
      this.bodyForm.append("provider_msg", this.form.controls.provider_msg.value);
      this.bodyForm.append("host", this.hostName);
      Swal.fire({
        icon: 'info',
        title: 'Subiendo archivo...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.projectService.uploadCampaignProviderFile(this.bodyForm).subscribe(
        (result:any)=>{
          if(result.message == 'Success'){
            Swal.fire({
              icon: 'success',
              title: 'Archivo subido',
              text: 'Archivo subido exitosamente'          
            }).then(() => {            
              this.dialogRef.close({ reload: true });
            });
          }
          else {
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
            });
          }
        },
        (err:any)=>{
          this.main.HideLoading();
          if(err.error.message == "Invalid file") {
            Swal.fire({
              icon: 'warning',
              title: 'Error',
              html: 'Solo se permiten documentos en formato .PDF'
            });
      
          }
          else {
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
            });
          }
        }
      )
      
  }else{
      Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: 'El documento no ha sido adjuntado'
      });
    }
  }


  loadproviderInfo(evento : any){
    this.main.ShowLoading();
    this.providerSelected = true;
    this.projectService.getProviderAdminView(evento.value).subscribe(
      (result:any) => {
       this.main.HideLoading();
       if(result.message == "Success") {
          this.members = result.data.members;
          this.members = this.members.filter((m:any) => m.active === 1); 
          this.filteredMembers = [...this.members];
          // Seleccionar todos los miembros por defecto
          const allMemberIds = this.members.map((m: any) => m.id);
          this.form.get('membersSelected')?.setValue(allMemberIds);
        }
      },
      (err:any) => {
        this.main.HideLoading();
        this.members = [];
        this.filteredMembers = [];
        this.form.get('membersSelected')?.setValue([]);
      }
    );
  }

  getPromotionsFile(){
    //this.main.ShowLoading();

    this.projectService.getPromotionData(this.campaign).subscribe((x: any) => {
        
          let resultado: any;
          let proveedor: any;
          let provSelec: number = 0;
          let loadInf: {value: number}[] = [];
          let encontroProv: number = 0;

          this.promociones.forEach((prom:any) => {
             resultado = x.data.find((item:any) => item["CODIGO PRINCIPAL"] === prom);
             if (resultado) {
              // Verifico si la propiedad PROVEEDOR
              if ("PROVEEDOR" in resultado && resultado.PROVEEDOR) {
                proveedor = this.providers.find((p: any) =>
                  resultado.PROVEEDOR.toLowerCase().includes(p.nombre.toLowerCase())
                );

                if (proveedor && encontroProv == 0) {
                  encontroProv = 1;
                  provSelec = proveedor.id;
                  loadInf = [];
                  loadInf.push({ value: provSelec });
                  this.loadproviderInfo(loadInf[0]);
                }
              }
             }
          })

          if (provSelec > 0) {
            this.form.get('id_provider')?.setValue(provSelec);
          } 

          this.main.HideLoading();

        },
        (err:any) => {
          console.log(err);
          this.main.HideLoading();
        })
  }



  onSelectOpened() {
    setTimeout(() => {
      this.searchInput?.nativeElement?.focus();
    }, 100);
  }

  filterMembers() {
    const term = (this.searchTerm || '').toLowerCase();
    const selectedIds = this.form.get('membersSelected')?.value || [];

    const selected = this.members.filter((m: any) => selectedIds.includes(m.id));
    const notSelected = this.members.filter((m: any) => !selectedIds.includes(m.id));

    const filteredNotSelected = notSelected.filter((m: any) => 
      m.nombre.toLowerCase().includes(term) || m.email.toLowerCase().includes(term)
    );

    this.filteredMembers = [...selected, ...filteredNotSelected];
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.filterMembers();
  }

  toggleSelectAllMembers() {
    const membersControl = this.form.get('membersSelected');
    const allMemberIds = this.members.map((p: any) => p.id);
    const currentSelection = membersControl?.value || [];

    membersControl?.setValue(currentSelection.length === allMemberIds.length ? [] : allMemberIds);
  }

  calculateTotal() {
    console.log("se empieza a hacer",this.pop_config);
    if (this.pop_config && Array.isArray(this.pop_config)) {
      this.total = this.pop_config.reduce((sum, item) => {
        return sum + ( (item.cantidad || 0) * (item.precio || 0) );
      }, 0);
    }
  }

  montoValidator(control: AbstractControl): ValidationErrors | null {
    if (!this.showMontoInput) {
      return null; // No validation if the checkbox is off
    }

    const configuredTotal = this.surveys_sended.reduce((sum: number, survey: any) => {
        return sum + (Number(survey.provider_price) || 0);
    }, 0);

    const remainingTotal = this.total - configuredTotal;
    const monto = Number(control.value);

    if (monto > remainingTotal) {
        return { maxAmountExceeded: { max: remainingTotal, current: monto } };
    }

    return null;
  }

  onMontoConfigChange() {
    const montoControl = this.form.get('monto');
    if (this.showMontoInput) {
      montoControl?.setValidators([Validators.required, this.montoValidator.bind(this), Validators.min(0)]);
    } else {
      montoControl?.clearValidators();
      montoControl?.setValue('');
    }
    montoControl?.updateValueAndValidity();
  }

}
